import { Axios } from 'utils/AxiosConfig'

export const getMembership = async (payload) => {
  const { data: response } = await Axios.get(`member/profile/subscription`, { params: payload })
  return response
}